import { render } from "./ForgotPassword.vue?vue&type=template&id=16be83b8&scoped=true&ts=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "@/assets/scss/sign-in.scss?vue&type=style&index=0&id=16be83b8&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16be83b8"]])

export default __exports__